const replacements = [
    { search: '-klas', replace: ' Клас' },
    { search: 'izpiti-', replace: 'Изпита за ' },
    { search: 'maturi-', replace: 'Матури за ' },
    { search: 'maturi-', replace: 'Матури за ' },
    { search: 'csharp-online', replace: 'C#' },
    { search: 'java-online', replace: 'Java' },
    { search: 'matura-profilirana-podgotovka', replace: 'Профилирана подготовка' },
    { search: 'himiya-kandidat-studenti', replace: 'Кандидат студенти' },
    { search: 'nivo-', replace: 'Ниво ' },
    { search: 'starters', replace: 'Начално' },
];

const applyReplacements = (str: string) => {
    for (const { search, replace } of replacements) {
        str = str.replace(search, replace);
    }
    return str;
};

const extractNumbers = (str: string): string => {
    return str.match(/\d+/g)?.join('') || '';
};

export { applyReplacements, extractNumbers };